export default __webpack_public_path__ + "assets/images/loadingLogo.1120b13c4535659a20ea9a45b54de580.svg";